import React from "react";
import ProjectLayout from "../components/ProjectLayout";
import heroImage from "../../../assets/Images/project/project-banner.png";

const PlanningProjects = () => {
  return (
    <>
    <ProjectLayout
      heroImage={heroImage}
      title="Planning"
      subtitle="All type land use planning - More than 2000.00 hectare "
      description="Included of Jaipur /Delhi based top most Builders, industrialist, Institutions and land developers sites residential Township planning, Row housing Planning, Group housing scheme planning, Industrial township planning and mix used planning. Municipal submission planning as per concern authority rule or byelaws."
      sector="PLANNING"
    />
    
    </>
  );
};

export default PlanningProjects;
